import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service'; // Adjust the path as necessary
import { UserPermissions } from '../model';

@Injectable({
  providedIn: 'root',
})
export class DetermineHomePageGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const accountId = this.authService.getCurrentAccountId();
    let homePageRoute = '/';
    if (state.url !== '/' && state.url !== '') {
      return true;
    }

    if (this.authService.hasPermission(UserPermissions.CensusManagement)) {
      homePageRoute = '/policies';
      this.router.navigate([accountId, 'policies']);
    } else if (this.authService.hasPermission(UserPermissions.QuotingManagement)) {
      homePageRoute = '/quotes';
      this.router.navigate([accountId, 'quotes']);
    } else if (this.authService.hasPermission(UserPermissions.UploadManagement)) {
      homePageRoute = '/uploads';
      this.router.navigate([accountId, 'uploads', 'enrolls']);
    } else if (this.authService.hasPermission(UserPermissions.CensusSearch)) {
      homePageRoute = '/tpa';
      this.router.navigate([accountId, 'tpa']);
    } else {
      homePageRoute = '/unauthorized';
      this.router.navigate(['/unauthorized']);
    }
    this.authService.homePageRoute = homePageRoute;
    return true;
  };
}
